"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _textfield = _interopRequireDefault(require("../textfield/textfield"));

var _button = _interopRequireDefault(require("../button"));

var _confirm = _interopRequireDefault(require("../../assets/icons/confirm.svg"));

var _cancel = _interopRequireDefault(require("../../assets/icons/cancel.svg"));

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TextfieldInlineEdit = function TextfieldInlineEdit(_ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      label = _ref.label,
      secondaryLabel = _ref.secondaryLabel,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      helperText = _ref.helperText,
      errorMsg = _ref.errorMsg,
      readOnly = _ref.readOnly,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      newValue = _useState2[0],
      setNewValue = _useState2[1];

  var buttonIconsRef = (0, _react.useRef)(null);

  var removeFocusFromInput = function removeFocusFromInput() {
    var _Array$from, _buttonIconsRef$curre;

    (_Array$from = Array.from((buttonIconsRef === null || buttonIconsRef === void 0 ? void 0 : (_buttonIconsRef$curre = buttonIconsRef.current) === null || _buttonIconsRef$curre === void 0 ? void 0 : _buttonIconsRef$curre.children) || [])) === null || _Array$from === void 0 ? void 0 : _Array$from.forEach(function (child) {
      child === null || child === void 0 ? void 0 : child.blur();
    });
  };

  (0, _react.useEffect)(function () {
    setNewValue(value);
  }, [value]);

  var resetInputValue = function resetInputValue() {
    setNewValue(value);
  };

  var handleInputChange = function handleInputChange(event) {
    setNewValue(event.target.value);
  };

  var handleInputBlur = function handleInputBlur(event) {
    var _event$relatedTarget;

    if ((event === null || event === void 0 ? void 0 : (_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.name) === _constants.confirmButtonName) {
      return;
    }

    resetInputValue();

    if (typeof onBlur === 'function') {
      onBlur(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    if (event.key === _constants.escapeKey) {
      event.preventDefault();
      event.target.blur();
      resetInputValue();
    }
  };

  var handleConfirmAction = function handleConfirmAction(event) {
    event.stopPropagation();

    if (onChange instanceof Function) {
      onChange(newValue);
    }

    removeFocusFromInput();
  };

  var handleCancelAction = function handleCancelAction() {
    resetInputValue();
    removeFocusFromInput();
  };

  var iconButtons = /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.inlineEditClasses.inlineEditButtons,
    ref: buttonIconsRef
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    name: _constants.confirmButtonName,
    variant: "textOnly",
    size: "small",
    onClick: handleConfirmAction
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _confirm.default
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    name: _constants.cancelButtonName,
    variant: "textOnly",
    size: "small",
    onClick: handleCancelAction
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _cancel.default
  })));

  var props = {
    type: 'text',
    value: newValue,
    placeholder: placeholder,
    disabled: disabled,
    width: width,
    height: height,
    variant: 'naked',
    label: label,
    secondaryLabel: secondaryLabel,
    error: error,
    errorMsg: errorMsg,
    helperText: helperText,
    readOnly: readOnly,
    icon: iconButtons,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    onKeyUp: handleKeyUp,
    onFocus: onFocus,
    styleClasses: _objectSpread(_objectSpread({}, _constants.rawTextClasses), {}, {
      variantNaked: (0, _utils.getNakedVariantClass)(newValue, placeholder, error),
      inputContainer: (0, _utils.getInputContainerClass)(readOnly)
    })
  };
  return /*#__PURE__*/_react.default.createElement(_textfield.default, props);
};

TextfieldInlineEdit.propTypes = {
  value: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  label: _propTypes.default.string,
  secondaryLabel: _propTypes.default.string,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.string,
  errorMsg: _propTypes.default.string,
  readonly: _propTypes.default.bool,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
};
var _default = TextfieldInlineEdit;
exports.default = _default;